import { roundDownToNearestHundred } from "../../../configs/utils";
let portfolioSearchKeyword = "";
let listBeforeSearchUI = [];
export const getTotalLimit = (availableCAS, isinNavMap, isinLTVMap) => {
    let sum = 0;
    availableCAS.forEach((item) => {
        sum =
            sum +
                roundDownToNearestHundred(item.pledgedUnits * isinNavMap[item.isinNo] * isinLTVMap[item.isinNo]);
    });
    return sum;
};
export const getActualLimit = (availableCAS, isinNavMap, isinLTVMap) => {
    let sum = 0;
    availableCAS.forEach((item) => {
        sum =
            sum +
                roundDownToNearestHundred(item.totalAvailableUnits *
                    isinNavMap[item.isinNo] *
                    isinLTVMap[item.isinNo]);
    });
    return sum;
};
export const getPortfolioValue = (availableCAS, isinNavMap) => {
    let sum = 0;
    availableCAS.forEach((item) => {
        sum =
            sum +
                roundDownToNearestHundred(item.totalAvailableUnits * isinNavMap[item.isinNo]);
    });
    return sum;
};
export const getDesiredValue = (availableCAS, isinNavMap) => {
    let sum = 0;
    availableCAS.forEach((item) => {
        sum =
            sum +
                roundDownToNearestHundred(item.pledgedUnits * isinNavMap[item.isinNo]);
    });
    return sum;
};
export const goBack = async (action, _datastore, { goBack }) => {
    goBack();
};
